import { atom } from "recoil";

const LoyaltyCatalogDataAtom = atom<any>({
    key: 'loyaltyCatalogDataAtomKey',
    default: null
})

export default LoyaltyCatalogDataAtom;